import React from "react";
import { Dialog, DialogContent, DialogTitle, DialogActions } from "@material-ui/core";

import Button from "../../../../../../components/common/PL/Button/Button";

import "./ReenviarNotificacionModal.css";

const OBSERVACIONES_MAX_LENGTH = 1000;

type ReenviarNotificacionModalProps = {
  open: boolean;
  onClose: () => void;
  onSubmit: () => void;
};

const ReenviarNotificacionModal: React.FC<ReenviarNotificacionModalProps> = ({
  open,
  onClose,
  onSubmit,
}) => {
  const [observaciones, setObservaciones] = React.useState<string>("");

  const handleClose = () => {
    setObservaciones("");
    onClose();
  };

  const handleSubmit = () => {
    setObservaciones("");
    onSubmit();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      PaperProps={{
        className: "reenviarNotificacionModalCard",
        onClick: (e: React.MouseEvent) => e.stopPropagation(),
      }}
      fullWidth
      maxWidth="sm"
    >
      <DialogTitle disableTypography className="reenviarNotificacionModalTitle">
        Reenviar notificación
      </DialogTitle>
      <DialogContent className="reenviarNotificacionModalContent">
        <span className="reenviarNotificacionModalSectionLabel">
          Observaciones para el autorizante
        </span>
        <textarea
          className="reenviarNotificacionModalTextArea"
          value={observaciones}
          onChange={(e) => setObservaciones(e.target.value.slice(0, OBSERVACIONES_MAX_LENGTH))}
          placeholder="-completar-"
          rows={3}
        />
        <span className="reenviarNotificacionModalCounter">
          {observaciones.length}/{OBSERVACIONES_MAX_LENGTH}
        </span>
      </DialogContent>
      <DialogActions className="reenviarNotificacionModalActions">
        <Button variant="outline" onClick={handleClose} className="reenviarNotificacionModalButton">
          Cancelar
        </Button>
        <Button
          variant="neutral"
          onClick={handleSubmit}
          className="reenviarNotificacionModalButton"
        >
          Enviar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ReenviarNotificacionModal;
